import * as React from 'react'
import Layout from "@components/common/layout/layout";
import DocsContent from "../../components/docs/docsContent/docsContent";
import DocsContact from "../../components/docs/docsContact/docsContact";
import Footer from "@components/common/footer/footer";
import Header from "@components/common/header/header";
import {redirectToTryForFree} from "../../utils/redirectToTryForFree";
import {getCustomPage, getSectionsWithPages} from "../../server-side/getDataServerSide";
import NoResultFound from "../../components/features/noResultFound/noResultFound";
import {useEffect} from "react";

const jsComposer = `${process.env.GATSBY_WEBSITE_URL}wp-content/plugins/js_composer/assets/css/js_composer.min.css`
const iconCss = `${process.env.GATSBY_WEBSITE_URL}wp-content/themes/trafft-theme/assets/icons/css/all.css`
const webflowCss = `${process.env.GATSBY_WEBSITE_URL}wp-content/themes/trafft-theme/assets/css/webflow.css`
const fontCss = `${process.env.GATSBY_WEBSITE_URL}wp-content/themes/trafft-theme/assets/css/timezy-industry.webflow.css`
const styleMin = `${process.env.GATSBY_WEBSITE_URL}wp-includes/css/dist/block-library/style.min.css`

export const Head = (serverData) => {
  const seoData = serverData.serverData.content.pages.edges[0].node.children.edges[0].node.seo;
  const pageLink = serverData.serverData.content.pages.edges[0].node.children.edges[0].node.link;

  return (
    <>
      <link rel="stylesheet" href={jsComposer}/>
      <link rel="stylesheet" href={iconCss}/>
      <link rel="stylesheet" href={webflowCss}/>
      <link rel="stylesheet" href={fontCss}/>
      <link rel="stylesheet" href={styleMin}/>

      <title>{seoData.title}</title>
      <meta name="title" content={seoData.title}/>
      <meta name="description" content={seoData.metaDesc} />
      <meta property="og:type" content="website"/>
      <meta property="og:url" content={pageLink} />
      <meta property="og:title" content={seoData.title} />
      <meta property="og:description" content={seoData.metaDesc} />
      <meta property="og:image" content="" />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={pageLink} />
      <meta property="twitter:title" content={seoData.title}/>
      <meta property="twitter:description" content={seoData.metaDesc} />
      <meta property="twitter:image" content="" />
      <link rel="canonical" href={pageLink}/>
    </>
  );
};

const WpData = ({serverData}) => {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = '';
    };
  }, []);
  return (
    serverData.content.pages.edges.length > 0 ?
      <Layout>
        <Header page='docs'/>
        <DocsContent
          sideContent={serverData.content.pages.edges}
          navigationContent={serverData.tabs.pages.edges}
          selectedHeadline={serverData.content.pages.edges[0].node.children.edges[0].node.slug}
        />
        <DocsContact/>
        <Footer
          animationColor='#005AEE'
          animationStopColor='#2F7EFF'
          buttonType='primary'
          buttonLabel='Try Now For Free'
          buttonOnClick={redirectToTryForFree}
        />
      </Layout>
      :
      <NoResultFound/>
  )
}

export async function getServerData(props) {
  const slug = props.params['category'];
  try {
    return {
      props: {
        content: await getCustomPage(slug, 'docs'),
        tabs: await getSectionsWithPages(),
      },
      status: 200,
    };
  } catch {
    return {
      props: {
        tabs: []
      },
      status: 500,
    };
  }
}

export default WpData
